export default __webpack_public_path__ + "static/media/image-express.53802593.jpg";